export default (theme) => ({
  editableInfoWrapper: {
    display: 'flex',
    width: '70%',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('ml')]: {
      width: '60%',
    },
    [theme.breakpoints.down('lg')]: {
      width: 'calc(100% - 140px)',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
  editButton: {
    minWidth: 100,
    width: 'auto',
    height: 44,
    marginLeft: 20,
    [theme.breakpoints.down('lg')]: {
      margin: '0 0 10px 0',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '&:first-of-type': {
      marginLeft: 0,
    },
  },
  editIcon: {
    fill: '#ffffff',
    width: 16,
    height: 16,
    marginRight: 5,
  },
  controlsWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column-reverse',
      alignSelf: 'flex-start',
      justifyContent: 'flex-end',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      width: '100%',
    },
  },
});
